export default {
  getTableSetting (state) {
    return state.tables
  }
}
